import { Select } from "@chakra-ui/react";
import capitalize from "@splitfire-agency/raiden-library/dist/libraries/utils/capitalize";
import { forwardRef } from "react";
import { isNullOrUndefined } from "../../../helpers/common/isNullOrUndifined";
import { useConfiguration } from "../../../hooks/useConfiguration";
import { usePreferredYear } from "../../../hooks/usePreferredYear";
import { useSchoolLevels } from "../../../hooks/useSchoolLevels";

const SchoolLevelSelect = forwardRef(
  /**
   * @typedef {Object} Props
   * @property {string} [schoolId]
   * @property {string} [environmentId]
   *
   * @param {Props} props
   */
  function SchoolLevelSelect(props, ref) {
    const { schoolId, environmentId, ...otherProps } = props;

    const preferredYear = usePreferredYear({ environmentId });

    const levels = useSchoolLevels({
      schoolId,
      environmentId,
      yearId: isNullOrUndefined(preferredYear)
        ? undefined
        : String(preferredYear?.id),
    });

    const { configuration } = useConfiguration();

    return (
      <Select ref={ref} {...otherProps}>
        <option value="">-</option>

        {levels
          .map((level) => ({
            value: level,
            name: capitalize(
              configuration?.globals?.schooling_levels?.[level]?.name ?? level,
            ),
          }))
          .map((level) => (
            <option key={level.value} value={level.value}>
              {level.name}
            </option>
          ))}
      </Select>
    );
  },
);

export default SchoolLevelSelect;
